import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ReactComponent as DownloadIcon } from '@src/assets/icons/download-logs.svg';
import { ArcIconButton, ArcStack, ArcText, ArcTooltip } from '@src/core/ui';
import { DroneHeaderProps } from './types';
import { useSelector } from 'react-redux';
import { selectDrone } from '@src/features/fleet/pages/drones-page/redux';
import { DroneRegisterForm } from '@src/features/fleet/components';
import { useDisclosure } from '@src/core/hooks';
import { useConfirm } from '@src/core/controllers';
import { toast } from 'react-toastify';
import { DroneEntity } from '@src/core/features';
import { useDeleteDroneMutation, useDroneLogsMutation } from '@src/features/fleet/redux/api';
import { arcDownloadFile } from '@src/core/extensions';

const DroneHeader: React.FC<DroneHeaderProps> = () => {
  const { confirm } = useConfirm();
  const { open, show, hide } = useDisclosure();
  const selectedDrone = useSelector(selectDrone) ?? {} as DroneEntity;

  const [ deleteDrone, { isLoading } ] = useDeleteDroneMutation();
  const [ downloadLogs, { isLoading: isDownloadingLogs } ] = useDroneLogsMutation();

  const onDeleteDrone = async () => {
    if (!selectedDrone.id) return;

    if (await confirm()) {
      deleteDrone(selectedDrone.id).unwrap().then(() => {
        toast.success('Delete Drone Success Text');
      }).catch(() => {});
    }
  };

  const onDownloadLogs = async () => {
    if (!selectedDrone.serialNumber) return;
    
    try {
      const url = await downloadLogs(selectedDrone.serialNumber).unwrap();
      const fileName = `${selectedDrone.serialNumber}_logs.zip`;
      arcDownloadFile(url, fileName);
    } catch (error: any) {
      const status = error?.status || error?.response?.status;
      if (status === 404) {
        toast.error('Logs not found for this drone');
      } else {
        toast.error('Failed to download logs');
      }
    }
  };

  return (
    <React.Fragment>
      <DroneRegisterForm 
        open={open}
        onClose={hide}
        title='Change name' 
        drone={selectedDrone} />
      <ArcStack spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
        <ArcStack spacing={1} direction='row' alignItems='center'>
          <ArcText.h3 fontWeight={500}> {selectedDrone.name} </ArcText.h3>
          <ArcText.h5 fontWeight={500} color='text.secondary'> {selectedDrone.serialNumber} </ArcText.h5>
        </ArcStack>

        <ArcStack spacing={2} direction='row' alignItems='center'>
          <ArcTooltip title='Update Firmware'>
            <ArcIconButton >
              <RefreshIcon />
            </ArcIconButton>
          </ArcTooltip> 
          {/*<ArcTooltip title='Download Error Logs'>
            <ArcIconButton onClick={onDownloadLogs} isLoading={isDownloadingLogs}>
              <DownloadIcon />
            </ArcIconButton>
          </ArcTooltip>*/}
          <ArcTooltip title='Rename Drone'>
            <ArcIconButton onClick={show}>
              <EditNoteIcon/>
            </ArcIconButton>
          </ArcTooltip>
          <ArcTooltip title='Delete Drone'>
            <ArcIconButton isLoading={isLoading} onClick={onDeleteDrone}>
              <DeleteOutlineIcon color='error' />
            </ArcIconButton>
          </ArcTooltip>
        </ArcStack>
      </ArcStack>
    </React.Fragment>
  );
};

export default DroneHeader;